import React from 'react';

import {ContinueShoppingButton} from '../continueShoppingButton/continueShoppingButton';

import s from '../successMessageWithoutDash.scss';

/**
 * Success screen on contact lenses
 * @returns {React.ReactNode} react template
 */
export const YouWillReceiveAConfirmation = React.memo(() => (
    <div className={s.wrapper}>
        <p className={s.description}>
            You’ll receive a confirmation email <br /> with your order details and tracking link.
        </p>
        <ContinueShoppingButton />
    </div>
));

YouWillReceiveAConfirmation.displayName = 'YouWillReceiveAConfirmation';
